interface OrnamentDividerProps {
  className?: string;
  variant?: 'gold' | 'dim';
}

export function OrnamentDivider({ className = '', variant = 'gold' }: OrnamentDividerProps) {
  const lineColor =
    variant === 'gold'
      ? 'from-transparent to-mafia-gold/50'
      : 'from-transparent to-mafia-border';

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div className={`flex-1 h-px bg-gradient-to-r ${lineColor}`} />
      <div className="flex items-center gap-1 text-mafia-gold select-none">
        <span className="text-[10px] leading-none">◆</span>
        <span className="text-sm leading-none">✦</span>
        <span className="text-[10px] leading-none">◆</span>
      </div>
      <div className={`flex-1 h-px bg-gradient-to-l ${lineColor}`} />
    </div>
  );
}
